module.exports = __webpack_public_path__ + "21f40c75c82a9d8884d83af9756a1f6e.png";